import axiosInstance from './axiosInstance';

export const createOrder = async (data) => {
  const response = await axiosInstance.post('/orders', data);
  return response.data;
};

export const getUserOrders = async () => {
  const response = await axiosInstance.get('/orders');
  return response.data;
};

export const getOrderById = async (orderId) => {
  const response = await axiosInstance.get(`/orders/${orderId}`);
  return response.data;
};

export const initializePayment = async (data) => {
  const response = await axiosInstance.post('/payments/initialize', data);
  return response.data;
};

export const verifyPayment = async (reference) => {
  const response = await axiosInstance.get(`/payments/verify/${reference}`);
  return response.data;
};